<div *ngIf="loaderService.isLoading | async" style="height: 100vh">
  <div class="hr-loader-area" style="height: inherit">
    <div class="loader">Loading...</div>
    <label>Aguarde enquanto a prévia da proposta está carregando.... </label>
    <p>Isso pode levar alguns segundos</p>
  </div>
</div>
<router-outlet></router-outlet>
